import React from 'react';
import Text from '@service-victoria/component-library/components/Text';
import Checkbox from '@service-victoria/component-library/components/Checkbox';
import { StepComponent } from '@service-victoria/component-library/components/Wizard/props';
import * as Interfaces from 'interfaces';
import * as Styled from '../styled';
import { constants } from 'utils';

type Values = Partial<Interfaces.Common.FormValues> & {
  consent?: boolean;
};

export type ComponentProps = StepComponent<Values>;

const VisitVictoria: React.FC<ComponentProps> = ({ context }) => {
  const { values } = context.form;
  let selectedIdProof;
  switch (values.identity?.proofType) {
    case 'licence':
      selectedIdProof = 'Victorian driver licence';
      break;
    case 'seniorsCard':
      selectedIdProof = 'Victorian seniors card';
      break;
    case 'proofOfAgeCard':
      selectedIdProof = 'Victorian proof of age card';
      break;
  }
  return (
    <Styled.Wrapper>
      <Text.Heading.H1 fontWeight={600}>Visit Victoria</Text.Heading.H1>
      <Text.Body>
        Visit Victoria delivers inspiration, ideas and information as you plan your next holiday in
        metropolitan Melbourne.
      </Text.Body>
      <Checkbox
        name='identity.subscribe'
        label='I would like Visit Victoria to email me useful ideas about things to do in metropolitan Melbourne'
      />
      <Text.Body>
        Visit Victoria will not pass on your details to any third parties and you may unsubscribe at
        any time.
      </Text.Body>
      <Styled.Spacer48 />
      <Text.Heading.H3 fontWeight='bold'>Consent & Declaration</Text.Heading.H3>
      <Text.Body>
        <i>By clicking &lsquo;I agree&rsquo; below you agree to the following three conditions:</i>
      </Text.Body>
      <Styled.ListOrdered>
        <Styled.ListItem>
          I agree to the{' '}
          <Text.Link
            value='privacy policy'
            href={constants.externalLinks.svPrivacy}
            target='_blank'
          />
        </Styled.ListItem>
        <Styled.ListItem>
          I agree my details may be shared with state government departments to establish the
          eligibility of my application for this support payment, including the verification of my
          selected identification:
          <Styled.List>
            <Styled.ListItem>{selectedIdProof}</Styled.ListItem>
          </Styled.List>
        </Styled.ListItem>
        <Styled.ListItem>
          I agree to{' '}
          <Text.Link
            value='the guidelines for the Melbourne Travel Voucher Scheme'
            href={constants.externalLinks.guidelines}
            target='_blank'
          />
        </Styled.ListItem>
      </Styled.ListOrdered>
    </Styled.Wrapper>
  );
};

export default VisitVictoria;
